/**
 * Google Analytics 4 (property G-0MHSXHSYLF).
 *
 * The tag itself loads from `index.html`, configured with
 * `send_page_view: false`. That is deliberate: this site is a `HashRouter`
 * SPA, so the route lives in the fragment, and the fragment is not part of
 * what GA files a hit under — its automatic page view would report every page
 * on the site as "/". Page views are sent from here instead, one per route,
 * with the route lifted out of the fragment and into `page_path`.
 *
 * Nothing here assumes `gtag` exists. An ad blocker, a privacy extension or a
 * blocked network request all leave the page working with no tag loaded, and
 * analytics is never a reason for a page to break.
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/** Local development shares the one property otherwise, and pollutes it. */
function isMeasurable(): boolean {
  const host = window.location.hostname;
  return host !== "localhost" && host !== "127.0.0.1" && host !== "";
}

/**
 * @param title the document title this route just set
 * @param url   the canonical URL, `https://neoncrowgames.com/#/games`
 */
export function trackPageView(title: string, url: string): void {
  if (typeof window.gtag !== "function" || !isMeasurable()) return;

  // "https://neoncrowgames.com/#/games" -> "/games". Everything before the
  // first "#" is the origin; an in-page anchor can add a second one.
  const path = url.split("#")[1]?.split("#")[0] || "/";

  window.gtag("event", "page_view", {
    page_title: title,
    page_path: path,
    page_location: url,
  });
}
